export const zIndex = {
  backgroundElements: 0, // Backgroundimages and videos
  overlayBackground: 2, // Text over image with gradient/background
  menuBackdrop: 3,
  portalBar: 2,
  slideShowBackground: 10,
  // Values below are MUI standard
  navbar: 1100,
  footer: 1100,
  floatingAction: 1050,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
}

//TODO: Add correct zIndex values for all components
